import { createBrowserClient } from "@supabase/ssr";

/** Navigateur : window.__ATS_PUBLIC__ injecté au démarrage Docker (voir docker/inject-public-env.ts). Build : process.env.* */
function publicSupabase(): { url: string; anon: string } {
  const w = typeof window !== "undefined" ? window.__ATS_PUBLIC__ : undefined;
  const p = typeof process !== "undefined" ? process.env : {} as Record<string, string | undefined>;
  const url = (w?.url || p.NEXT_PUBLIC_SUPABASE_URL || "").trim();
  const anon = (w?.anon || p.NEXT_PUBLIC_SUPABASE_ANON_KEY || "").trim();
  return { url, anon };
}

let _warned = false;

export function createClient() {
  const { url, anon } = publicSupabase();
  if (!url || !anon) {
    if (!_warned) {
      _warned = true;
      console.warn(
        "[supabase] Supabase URL / clé anon manquantes — auth et sync désactivés. " +
        "Renseigne NEXT_PUBLIC_SUPABASE_URL et NEXT_PUBLIC_SUPABASE_ANON_KEY dans .env pour activer."
      );
    }
    // Return a dummy client pointing to a placeholder — all calls will fail gracefully
    return createBrowserClient("https://placeholder.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.placeholder");
  }
  return createBrowserClient(url, anon);
}
